<div class ="p-4">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Stromflussdiagramm vom Gerät:&nbsp;{{ cData?.deviceName ?? "" }} vom {{ cData?.dateDatapoints ?? "" }} </h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>
    <div class="d-flex justify-content-between" >
        <h5 class="fw-semibold">Brennstoffzellendaten von {{ cData?.timeFuelCellDatapoint ?? ""}} Uhr</h5>
        <h5 class="fw-semibold" [style.background-color] ="cData?.isCombinationValid == false ? 'red' : 'transparent'">
                Solardaten von {{ cData?.timeSolarChargerDatapoint ?? ""}} Uhr</h5>
    </div>
    <div class="diagram-canvas">
        <ng-diagram  [model]="model" [config]="config" [nodeTemplateMap]="nodeTemplateMap" [edgeTemplateMap]="edgeTemplateMap"/>
    </div>
</div>